"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataState = void 0;
const React = __importStar(require("react"));
const antd_1 = require("antd");
const NewUsersPopover_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/common/help/NewUsersPopover");
const PageContent_1 = __importDefault(require("src/hello_assets/src/components/ui/common/content/PageContent"));
const react_router_dom_1 = require("react-router-dom");
const NewUsersFormComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/newUsers/state/data/form/NewUsersFormComponent");
const NewUsersHighchartsComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/newUsers/state/data/NewUsersHighchartsComponent");
const NewUsersPageDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/newUsers/NewUsersPageDataProvider");
const NewUsersPageModelProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/newUsers/NewUsersPageModelProvider");
const NewUsersExportHighchartsButton_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/newUsers/state/data/NewUsersExportHighchartsButton");
const NewUsersPageHighchartsOptionsProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/newUsers/state/data/NewUsersPageHighchartsOptionsProvider");
const NewUsersChartSettingsComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/newUsers/state/data/highchartsSettings/NewUsersChartSettingsComponent");
const DataState = () => {
    return React.createElement(React.Fragment, null,
        React.createElement(NewUsersPageHighchartsOptionsProvider_1.NewUsersPageHighchartsOptionsProvider, null,
            React.createElement(antd_1.PageHeader, { title: React.createElement(antd_1.Space, null,
                    React.createElement(React.Fragment, null, "New Users"),
                    React.createElement(NewUsersPopover_1.NewUsersPopover, null)), extra: React.createElement(antd_1.Space, null,
                    React.createElement(NewUsersExportHighchartsButton_1.NewUsersExportHighchartsButton, null)) }),
            React.createElement(PageContent_1.default, null,
                React.createElement(PageContent_1.default.Card, null,
                    React.createElement(NewUsersChartSettingsComponent_1.NewUsersChartSettingsComponent, null),
                    React.createElement(NewUsersHighchartsComponent_1.NewUsersHighchartsComponent, null)),
                React.createElement(PageContent_1.default.CardSpacer, null),
                React.createElement(PageContent_1.default.Card, null,
                    React.createElement(antd_1.Row, null,
                        React.createElement(antd_1.Col, { span: 24 },
                            React.createElement(NewUsersFormComponent_1.NewUsersFormComponent, null)))))),
        process.env.NODE_ENV === "development" ? React.createElement(DebugView, null) : null);
};
exports.DataState = DataState;
const DebugView = () => {
    const pageDataContext = (0, NewUsersPageDataProvider_1.useNewUsersPageDataContext)();
    const pageModelContext = (0, NewUsersPageModelProvider_1.useNewUsersPageModelContext)();
    const location = (0, react_router_dom_1.useLocation)();
    return React.createElement(React.Fragment, null,
        React.createElement(PageContent_1.default.CardSpacer, null),
        React.createElement(PageContent_1.default.Card, null,
            React.createElement(antd_1.Row, { gutter: [16, 16] },
                React.createElement(antd_1.Col, { span: 24 },
                    "location:",
                    React.createElement("br", null),
                    React.createElement("span", { style: { fontSize: "10px", maxHeight: 180, wordBreak: "break-all" } }, decodeURI(location.search))),
                React.createElement(antd_1.Col, { span: 8 },
                    "pageModelFormState:",
                    React.createElement("br", null),
                    React.createElement("pre", { style: { fontSize: "10px", maxHeight: 250 } }, JSON.stringify(pageModelContext.pageModelFormState, null, 4))),
                React.createElement(antd_1.Col, { span: 8 },
                    "dataURLState:",
                    React.createElement("br", null),
                    React.createElement("pre", { style: { fontSize: "10px", maxHeight: 250 } }, JSON.stringify(pageDataContext.urlState, null, 4))),
                React.createElement(antd_1.Col, { span: 8 },
                    "dataState:",
                    React.createElement("br", null),
                    React.createElement("pre", { style: { fontSize: "10px", maxHeight: 250 } }, JSON.stringify(pageDataContext.state, null, 4)))),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("br", null)));
};
